import { breakpointsVariables } from 'styles/breakpoints.variables';

export const minWidth = (query: string, content: string): string => {
  if (!breakpointsVariables[query] || !breakpointsVariables[query].min) {
    return content;
  }

  return `@media screen and (min-width: ${breakpointsVariables[query].min}) { ${content} }`;
};

/* https://stackoverflow.com/questions/16348489/is-there-a-css-hack-for-safari-only-not-chrome */
export const fixSafari = (
  content: string
) => `@media not all and (min-resolution:.001dpcm)
    { @supports (-webkit-appearance:none) and (stroke-color:transparent) {
      ${content}
    }}`;
